<div class="cochera-view">
    @if (tieneNiveles) {
        <div class="nivel-buttons">
            @for (cochera of cocheras; track $index) {
                <button type="button" class="p-button p-button-success" (click)="viewNivel=cochera.nivel" [class.active]="viewNivel==cochera.nivel">Nivel {{cochera.nivel}}</button>
            }
        </div>
        
        @for (cochera of cocheras; track $index) {
            @if (viewNivel==cochera.nivel) {
                <div>
                    <h3>Nivel {{cochera.nivel}}</h3>
                    <div class="cocheras-container">
                        <div *ngFor="let unidad of cochera.unidades" class="cochera" [class.ocupada]="unidad.ocupada" [class.selected]="unidad.numero==selectedNumero && cochera.nivel==selectedNivel" (click)="select(cochera.nivel,unidad.numero)">
                            <p [title]="unidad.label ? 'Nº ' + unidad.numero : ''">{{unidad.label || unidad.numero}}</p>
                        </div>
                    </div>
                </div>
            }
        }
    }@else{
        <div class="nivel-buttons"></div>
        <div class="cocheras-container">
            @for (unidad of cocheras?.unidades; track $index) {
                <div class="cochera" [class.ocupada]="unidad.ocupada" [class.selected]="unidad.numero==selectedNumero" (click)="select(0,unidad.numero)">
                    <p [title]="unidad.label ? 'Nº ' + unidad.numero : ''">{{unidad.label || unidad.numero}}</p>
                </div>
            }
        </div>
    }
</div>
